/* put your custom js here */

/* ------------------------------------------------------------------ */
/* ShipCheck protection widget — pin it directly above the Checkout    */
/* button in the cart drawer + cart page. The app injects it higher up  */
/* (it can't anchor to our custom checkout button) and re-injects on    */
/* every cart re-render, so we relocate it each time via a lightweight  */
/* observer. Our checkout button has id="cartBtn" in both the drawer    */
/* and the main cart, so we insert the widget right before it.          */
/* ------------------------------------------------------------------ */
(function () {
  function place() {
    var w = document.querySelector('shipcheck-cart-widget');
    if (!w) return;
    var btn = document.getElementById('cartBtn');
    if (!btn) return;
    /* On the cart page the button now lives inside .bb-cart-form__pin, the
       wrapper that becomes the fixed bottom bar on phones. Anchor on that
       wrapper when it exists, NOT on the button, for two reasons:
         - desktop: bb-cart.css positions this widget with
           `.bb-cart-form > shipcheck-cart-widget { order: 2 }`, a CHILD
           selector. Inserting it beside the button would make it a child of
           the wrapper instead, the rule would stop matching, and the widget
           would lose its order and jump to the top of the summary card.
         - mobile: it belongs in the in-flow card above the pinned bar, not
           inside the bar.
       The drawer has no wrapper, so closest() returns null and this falls back
       to the button exactly as before. */
    var anchor = (btn.closest && btn.closest('.bb-cart-form__pin')) || btn;
    if (!anchor.parentNode) return;
    if (anchor.previousElementSibling === w) return; // already in place
    anchor.parentNode.insertBefore(w, anchor);
  }
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    var run = function () { pending = false; place(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else window.setTimeout(run, 16);
  }
  function init() {
    schedule();
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
